import { useContext, useCallback, useEffect } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { useFileDisplay } from 'hooks/useFileDownload'
import FlashMessagesContext from 'services/FlashMessages/context'
import { FILE_NAME_POSITION } from './constants'
import type { CmsDocumentBlockProps } from './types'

const useCmsDocumentBlock = ({ data }: CmsDocumentBlockProps) => {
  const { t } = useFavurTranslation()
  const { setFlashMessage, removeAll } = useContext(FlashMessagesContext)
  const { displayFile, error: displayError } = useFileDisplay()
  const { filename, filesize, src } = data
  const viewFile = useCallback(async () => {
    const viewFilename = src.substring(src.lastIndexOf('/') + FILE_NAME_POSITION)

    await displayFile({ url: src, filename: viewFilename })
  }, [src, displayFile])

  useEffect(() => {
    removeAll()

    if (displayError) {
      setFlashMessage(t('page.documents.download.error'))
    }
  }, [displayError, removeAll, setFlashMessage, t])

  return { filename, filesize, viewFile }
}

export default useCmsDocumentBlock
